import type { GameConfig } from "./types";

export const GAME_CONFIG: GameConfig = {
  laneCount: 4,
  minSpeed: 170,
  maxSpeed: 780,
  cruiseSpeed: 480,
  acceleration: 205,
  braking: 430,
  coastDeceleration: 95,
  trafficAcceleration: 105,
  trafficBraking: 320,
  trafficEmergencyBraking: 620,
  boostSpeed: 220,
  boostDuration: 0.8,
  boostCooldown: 5.8,
  laneChangeDuration: 0.24,
  safeForwardGap: 150,
  safeBackGap: 104,
  trafficMinGap: 72,
  trafficTimeGap: 0.34,
  spawnMinGap: 210,
  collisionMargin: 10,
  baseSpawnInterval: 0.92,
  minSpawnInterval: 0.34,
  difficultyRamp: 0.012
};

export const COLORS = ["#f05d5e", "#f2c14e", "#4cc9f0", "#b8f2e6", "#7b61ff", "#f7a072"];
